<template>
	<div>
		<label
			:for="id"
			class="text-sm font-medium text-gray-700 mb-1"
			:class="[labelClass, { 'text-red-600': field.$error }]"
		>
			{{ label }}
		</label>

		<slot :attrs="controlAttrs" />

		<span v-if="firstError" class="text-red-600 text-sm">
			{{ $t(`validation.${firstError.type}`, firstError) }}
		</span>
	</div>
</template>

<script setup lang="ts">
import type { ValidationField } from "~/types/account";

interface Props {
	id: string;
	label: string;
	field: ValidationField;
	/** Extra label classes, e.g. `capitalize` where the copy needs it. */
	labelClass?: string;
}

const { id, label, field, labelClass = "" } = defineProps<Props>();

const firstError = computed(() =>
	field.$error ? field.$errors[0]?.$params : undefined
);

/** One object so `v-bind="attrs"` keeps label and control in sync. */
const controlAttrs = computed(() => ({
	id,
	class: [
		"appearance-none relative block w-full px-3 py-2 border placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm",
		field.$error ? "border-red-600" : "border-gray-300"
	],
	"aria-invalid": field.$error || undefined
}));
</script>
